import React, { useState, useEffect } from 'react';
import { PropertyCard, PropertyDrawer } from '@/./pages/property/components';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '@store';
import { useNavigate } from 'react-router-dom';
import {
	fetchPropertyInfo,
	fetchPropertyDataset,
	resetPropertyData,
	fetchSalesAndFinancingList,
	fetchMarshalEvictionsList,
	fetchHPDComplaintsAndProblemsList,
	fetchHPDViolationsList,
	fetchDOBComplaintsList,
	fetchDOBViolationsList,
	fetchECBViolationsList,
	fetchDobFiledPermits,
	fetchDobIssuedPermits,
	fetchHousingLitigations,
} from '@/store/propertySlice';

export const Property: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();
	const [drawerIsOpen, setDrawerIsOpen] = useState(true);
	const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);
	const { addressState } = useSelector(
		(state: RootState) => state.rootSlice.application
	);
	const {
		properties: {
			addendum: {
				pad: { bbl },
			},
		},
	} = addressState;
	useEffect(() => {
		console.log("...", bbl)
		if (!bbl) navigate('/lookup', { replace: true });
		const handleResize = () => setIsLargeScreen(window.innerWidth >= 768);
		window.addEventListener('resize', handleResize);
		bbl && fetchAllPropertyData();

		return () => {
			dispatch(resetPropertyData());
			window.removeEventListener('resize', handleResize);
		};
	}, [addressState]);

	const fetchAllPropertyData = async () => {
		const payload = { bbl, format: 'json' };
		try {
			await Promise.all([
				dispatch(fetchPropertyInfo(bbl)),
				dispatch(fetchPropertyDataset()),
				dispatch(fetchSalesAndFinancingList(payload)),
				dispatch(fetchMarshalEvictionsList(payload)),
				dispatch(fetchHPDComplaintsAndProblemsList(payload)),
				dispatch(fetchHPDViolationsList(payload)),
				dispatch(fetchDOBComplaintsList(payload)),
				dispatch(fetchDOBViolationsList(payload)),
				dispatch(fetchECBViolationsList(payload)),
				dispatch(fetchDobFiledPermits(payload)),
				dispatch(fetchDobIssuedPermits(payload)),
				dispatch(fetchHousingLitigations(payload)),
			]);
		} catch (error) {
			console.error('Error fetching property data:', error);
		}
	};

	return (
		<div className="flex flex-col md:flex-row w-full">
			{/* Sidebar - Always visible on small screens, Toggle on large screens */}
			<div
				className={` relative flex-none transition-all duration-300 ${
					drawerIsOpen || !isLargeScreen ? 'w-full md:w-[333px]' : 'w-0 md:w-0'
				}`}
			>
				<PropertyDrawer
					isOpen={drawerIsOpen || !isLargeScreen} // Always open on small screens
					onToggle={() => setDrawerIsOpen(!drawerIsOpen)}
				/>
			</div>

			{/* Main Content Area (Adjustable Width on Large Screens) */}
			<div
				className={`transition-all duration-300 ${
					drawerIsOpen && isLargeScreen ? 'w-[calc(100%-333px)]' : 'w-full'
				}`}
			>
				<PropertyCard />
			</div>
		</div>
	);
};
